export const TAKE_AWAY = {
  id: "takeaway",
  label: "Takeaway"
};
export const DELIVERY = {
  id: "delivery",
  label: "Delivery"
};
export const HOME_DELIVERY = {
  id: "home_delivery",
  label: "Home delivery"
};
export const ORDERTYPES = [TAKE_AWAY, DELIVERY, HOME_DELIVERY];
